export function loadUnorm() {
  let promise = Promise.resolve()
  if (!String.prototype.normalize) {
    promise = promise.then(() => import('unorm'))
  }
  return promise
}
